'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var mh = require('multihashing-async');

var CID = require('cids');

var persist = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(buffer, block, options) {
    var multihash, cid;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!options.codec) {
              options.codec = 'dag-pb';
            }

            if (!options.cidVersion) {
              options.cidVersion = 0;
            }

            if (!options.hashAlg) {
              options.hashAlg = 'sha2-256';
            }

            if (options.hashAlg !== 'sha2-256') {
              options.cidVersion = 1;
            }

            _context.next = 6;
            return mh(buffer, options.hashAlg);

          case 6:
            multihash = _context.sent;
            cid = new CID(options.cidVersion, options.codec, multihash);

            if (options.onlyHash) {
              _context.next = 11;
              break;
            }

            _context.next = 11;
            return block.put(buffer, _objectSpread(_objectSpread({}, options), {}, {
              cid: cid
            }));

          case 11:
            return _context.abrupt("return", cid);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function persist(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

module.exports = persist;